import * as types from '../../../lib/actionTypes.es6';

export const initialState = {
  errors: null,
  loader: false,
  // True while a progressive (fetchAll) load is still pulling later slices.
  // The rows already fetched are on screen and usable; `loader` covers only
  // the wait for the very first slice.
  loadingMore: false,
  policies: [],
  page: 1,
  size: 20,
  total: 0,
  totalPages: 0,
  success_message: ''
};

export default function recentPoliciesReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_RECENT_POLICIES_REQUEST:
      return { 
        ...state, 
        loader: true, 
        errors: null
      };
      
    case types.GET_RECENT_POLICIES_SUCCESS:
      const { data, page, size, total } = action.payload;
      return {
        ...state,
        loader: false,
        loadingMore: !!action.payload.loadingMore,
        errors: null,
        policies: data || [],
        page: page || 1,
        size: size || 20,
        total: total || 0,
        totalPages: Math.ceil((total || 0) / (size || 20))
      };

    // A later slice of a progressive load: append, keeping everything the
    // user can already see and scroll.
    case types.GET_RECENT_POLICIES_CHUNK:
      return {
        ...state,
        loader: false,
        loadingMore: !!action.payload.loadingMore,
        errors: null,
        policies: state.policies.concat(action.payload.data || []),
        total: action.payload.total || state.total
      };

    case types.GET_RECENT_POLICIES_FAILURE:
      return {
        ...state,
        loader: false,
        loadingMore: false,
        errors: action.payload,
        policies: [],
        total: 0,
        totalPages: 0
      };

    default:
      return state;
  }
}